import { fire, on } from "delegated-events";

export class SearchPill {
    
    cssClass = "c-searchpill";
    inputItemClass = `${this.cssClass}__inputs-item`;
    inputControlClass = `${this.cssClass}__input-control`;

    constructor(el = null) {
        this.el = el;
        this.init();
    }

    init(){   
        on("click", `.${this.inputItemClass}`, (event) => {
            var target = event.target;
            if( target.matches(`.${this.inputItemClass}`) ){
                var inputControl = target.querySelector(`.${this.inputControlClass}`);
                console.log("DOMELEMENT:");
                console.log(inputControl);
                if( inputControl !== null ){
                    if( inputControl.tagName == "INPUT" ){
                        inputControl.focus();
                    }else if(inputControl.tagName == "SELECT"){
                        inputControl.click();
                    }
                }
            }
        })
    }

}